(function() {
    'use strict';

    angular
        .module('fileUploadApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'pr.longpress',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'pascalprecht.translate',
            'FileManagerApp'
        ])
        .run(run)
        .config(['fileManagerConfigProvider', function (config) {
        	  config.set({
        	    appName: 'angular-filemanager',
        	    listUrl: 'api/fileManager/post',
                uploadUrl: 'api/fileManager/post/upload',
                renameUrl: 'api/fileManager/post',
                copyUrl: 'api/fileManager/post',
                moveUrl: 'api/fileManager/post',
                removeUrl: 'api/fileManager/post',
                editUrl: 'api/fileManager/post',
                getContentUrl: 'api/fileManager/post',
                createFolderUrl: 'api/fileManager/post',
                downloadFileUrl: 'api/fileManager/get',
                downloadMultipleUrl: 'api/fileManager/get',
                compressUrl: 'api/fileManager/post',
                extractUrl: 'api/fileManager/post',
                permissionsUrl: 'api/fileManager/post',
        	    tplPath: 'bower_components/angular-filemanager/src/templates',
        	    hideDate: false,
        	    hidePermissions: true
        	  });
        	}]);/**/

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();
